import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';
import { NavLink } from 'react-router-dom';
import { baseShadowStyle } from '@shared/style/base-shadow';
import { Typography } from '@shared/ui/typography/typography';

export const Wrapper = styled(NavLink)`
    display: inline-grid;
    width: 100%;
    height: 152px;
    padding: 20px;
    background-color: ${COLORS.neutral_00};
    border-radius: 20px;
    ${baseShadowStyle};

    &:hover {
        cursor: pointer;
        transform: scale(0.92);
        transition: transform 0.3s ease;
    }
`;

export const IconWrapper = styled('div')`
    display: flex;
    width: 32px;
    height: 32px;
    margin-bottom: 40px;

    svg {
        width: 32px;
        height: 32px;
        color: ${COLORS.bright_blue};
    }
`;

export const Text = styled(Typography)`
    word-break: break-word;
`;
